import { giphyDarkCharcoal, giphyLightGrey, giphyWhite } from '@giphy/colors'
import { useContext, useEffect } from 'react'
import EllipsisDropdown from 'shared/components/ui/ellipsis-dropdown'
import MessageContext from 'shared/contexts/message'
import UserContext from 'shared/contexts/user'
import styled, { css } from 'styled-components'
import CreationToolGradient from '../../../../../types/gradient'
import CreationToolUIAnimation from '../../../../../types/ui-animation'
import { CreationCaptureInfoContext } from '../../../../supercut/shared/components/capture-info/manager'
import API from '../../../../supercut/shared/utils/api'
import { ICustomFont } from '../../types'

const api = new API()

const Preview = styled.div`
    cursor: pointer;
    height: 50px;
    background-color: ${giphyDarkCharcoal};
    margin: 8px 0px;
    text-align: center;
    display: flex;
    align-items: center;
    border-radius: 4px;
`

const Checkmark = styled.i<{ active?: boolean }>`
    background: ${giphyLightGrey};
    border-radius: 50%;
    color: #000;
    font-size: 12px;
    height: 20px;
    line-height: 22px;
    width: 20px;
    margin-right: 10px;

    ${({ active }) =>
        active &&
        css`
            ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
            visibility: visible;
            background: linear-gradient(
                45deg,
                ${CreationToolGradient.colors(CreationToolGradient.BlueGreen)[0]},
                ${CreationToolGradient.colors(CreationToolGradient.BlueGreen)[1]}
            );
        `}
`

const Title = styled.div<{ fontName: string }>`
    margin: auto auto auto 17px;
    color: ${giphyWhite};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 90%;
    font-size: 17px;
    font-family: '${(props) => props.fontName}';
`

const EllipsisButton = styled.div`
    cursor: pointer;
    color: ${giphyWhite};
    height: 30px;
    margin-right: 20px;
`

const EllipsisItem = styled.div`
    cursor: pointer;
`

type Props = {
    font: ICustomFont
    currentlySelected: boolean
}

const FontPreviewItem = ({ font, currentlySelected }: Props) => {
    const { setFont, setPreviousFonts, previousFonts } = useContext(CreationCaptureInfoContext)
    const { user } = useContext(UserContext)
    const { sendMessage } = useContext(MessageContext)
    const dynamicFontName = `uploadedFont-${font.filename}`

    useEffect(() => {
        const loadFont = async () => {
            const fontFace = new FontFace(dynamicFontName, `url(${font.fontUrl})`)
            // @ts-ignore
            document.fonts.add(fontFace)
            await fontFace.load()
        }
        loadFont()
    }, [])

    const onChooseClick = () => {
        if (currentlySelected) {
            setFont()
        } else {
            setFont(font)
        }
    }

    const onDelete = async () => {
        if (currentlySelected) {
            setFont()
        }
        setPreviousFonts(previousFonts.filter((fnt) => fnt.id !== font.id))
        try {
            await api.deleteFont(user.username, font.id)
        } catch (e) {
            sendMessage(`Unable to delete font.`, 'error')
        }
    }

    return (
        <Preview onClick={onChooseClick}>
            <Title fontName={dynamicFontName}>{font.filename.split('.')[0]}</Title>
            <Checkmark className="ss-check" active={currentlySelected} />
            <EllipsisButton onClick={(evt) => evt.stopPropagation()}>
                <EllipsisDropdown isHover={true} extendDirectionUp={true}>
                    <EllipsisItem onClick={onDelete}>Delete</EllipsisItem>
                </EllipsisDropdown>
            </EllipsisButton>
        </Preview>
    )
}

export default FontPreviewItem
